export default __webpack_public_path__ + "a43295875641dc531aa998621929865e.png";